import { useEffect, useRef } from "react";

export default function useComponentVisible(callback) {
  const refCallBack: any = useRef();
  const ref: any = useRef();
  useEffect(() => {
    refCallBack.current = callback;
  });
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      refCallBack.current(event);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  return ref;
}
